export const AUTH_OTP_RESEND_COOLDOWN = 60;
